import { BikeSpec } from './types';

/** KTM 125 SX (2024). KTM spec sheet: 124.8 cc 2T, 6 speed, 88.9 kg without fuel. Peaky: little below 8000 rpm. */
export const KTM125SX: BikeSpec = {
  id: 'ktm125sx', brand: 'KTM', name: '125 SX', year: 2024, kind: 'mx', stroke: '2T', displacement: 125,
  dryMass: 88.9, peakPower: 28, peakPowerRpm: 12000, peakTorque: 23, peakTorqueRpm: 11000, limiterRpm: 13000, idleRpm: 1800,
  torqueCurve: [[1800, 0.2], [5000, 0.3], [8000, 0.55], [10000, 0.9], [11000, 1], [12000, 0.97], [13000, 0.75]],
  primary: 73 / 23, gearbox: [32 / 13, 30 / 15, 28 / 17, 26 / 19, 25 / 21, 23 / 22], finalDrive: 48 / 13,
  travelFront: 310, travelRear: 300, seatHeight: 958, wheelbase: 1485,
  level: 'intermediate', discipline: 'track', livery: 'factory',
  model: { file: 'fleet/ktm125sx.glb', base: 'KTM 250 SX-F', approximate: true },
  audio: { set: '2t', pitch: 1.18 },
  estimated: ['peakPower', 'peakTorque', 'limiterRpm', 'torqueCurve'],
};
